module.exports = __webpack_public_path__ + "static/media/skila-bg_img-02-2-pod_600px_width-0_1-@1x.39b7bf84.png";